export default __webpack_public_path__ + "static/media/pencil-grey.360cbe6e.svg";